import React from 'react';

const VideoSection = () => {
  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] relative group p-6 md:p-8 mt-6 w-full">
      <h3 className="text-lg font-semibold text-purple-900 mb-4">Featured Video</h3>
      <div className="relative pt-[56.25%] w-full rounded-xl overflow-hidden">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/2TaLfVkV2mk"
          title="Coach HT - The PHYT Method"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default VideoSection; 